import packageJson from '../../package.json';


export const DEV_ENV = 'dev';
export const TEST_ENV = 'test';
export const B2B_PROD_ENV = 'b2b_prod';
export const PROD_ENV = 'prod';

export const APP_ENV = PROD_ENV;

export const API_TRAVELS_URL = (APP_ENV === DEV_ENV) ? "http://localhost:4000" :
    (APP_ENV === TEST_ENV) ? "https://staging-agent-server.appspot.com" :
        (APP_ENV === PROD_ENV) ? "https://srms-travels-server.qwikbus.co.in"
        :"https://b2b-agent-server.qwikbus.co.in";

export const ADMIN_CLIENT_BASE_URL = (APP_ENV === DEV_ENV) ? "http://localhost:3000" :
    (APP_ENV === TEST_ENV) ? "https://staging-admin-client.appspot.com" :
    (APP_ENV === PROD_ENV) ? "https://admin-manager-client.appspot.com"
        :"https://b2b-travels-admin-client.appspot.com";

export const API_ADMIN_URL = (APP_ENV === DEV_ENV) ? "http://localhost:5000" :
    (APP_ENV === TEST_ENV) ? "https://staging-admin-server.appspot.com" :
    (APP_ENV === PROD_ENV) ? "https://admin-manager-server.appspot.com"
        :"https://b2b-travels-admin.appspot.com";

export const API_B2B_ADMIN_BASE_URL = (APP_ENV === DEV_ENV) ? "http://localhost:5000" :
    (APP_ENV === TEST_ENV) ? "https://staging-admin-server.appspot.com" :
        "https://b2b-travels-admin.appspot.com";

export const API_SRMS_ADMIN_BASE_URL = (APP_ENV === DEV_ENV) ? "http://localhost:5000" :
    (APP_ENV === TEST_ENV) ? "https://staging-admin-server.appspot.com" :
        "https://admin-manager-server.appspot.com";

export const API_SRMS_BASE_URL = (APP_ENV === DEV_ENV) ? "http://localhost:4000" :
    (APP_ENV === TEST_ENV) ? "https://staging-agent-server.appspot.com" :
        "https://srms-travels-server.qwikbus.co.in";

export const API_NORTH_BASE_URL = (APP_ENV === DEV_ENV) ? "http://localhost:4000" :
    (APP_ENV === TEST_ENV) ? "https://staging-agent-server.appspot.com" :
        "https://north-travels-server.qwikbus.co.in";

export const API_NORTH_ADMIN_URL = (APP_ENV === DEV_ENV) ? "http://localhost:5000" :
    (APP_ENV === TEST_ENV) ? "https://staging-admin-server.appspot.com" :
        "https://north-admin-server.appspot.com";

export const API_B2B_BASE_URL = (APP_ENV === DEV_ENV) ? "http://localhost:4000" :
        (APP_ENV === TEST_ENV) ? "https://staging-agent-server.appspot.com" :
            "https://b2b-agent-server.qwikbus.co.in";

export const BUS_CANCELLATION_EMAIL_ADDRESS="raghu@dafidy.com";

// Token validated by travels server against app_config key EXTERNAL_API_TOKEN
export const EXTERNAL_API_TOKEN = (APP_ENV === DEV_ENV || APP_ENV === TEST_ENV) ? "2768958c-92fa-4573-b1ca-dac618135ff8" :
    "a470e1b8-702e-4597-abd5-a8bceb89496e";

export const TRACKING_BASE_URL = "https://tracking.qwikbus.in";

export const WEB_RELEASE_VERSION = packageJson.version;

export const AGENT_SERVER_URL_LIST = (APP_ENV === DEV_ENV) ? ["http://localhost:4000"] :
    (APP_ENV === TEST_ENV) ? ["https://staging-agent-server.appspot.com"] :
        ["https://srms-travels-server.qwikbus.co.in","https://b2b-agent-server.qwikbus.co.in","https://north-travels-server.qwikbus.co.in"];


